<template>
  <v-container>
    <TableFilter
      :headers="headers"
      filterName="elevator"
      @changeFilter="filterChanged"
    />
    <v-progress-linear
      indeterminate
      :active="loader"
      color="primary"
    />
    <div class="text-right">
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                class="my-4"
                :length="length"
                :total-visible="7"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-for="item in items" :key="item.id">
        <StatisticItem
          :item="item" />
    </div>
    <v-alert
      border="bottom"
      colored-border
      type="warning"
      elevation="2"
      v-if="items.length === 0"
      class="mb-5 text-center"
    >
      {{ $t('display/elevator:statistic.no-item') }}
    </v-alert>
  </v-container>
</template>

<script>
import ElevatorHeader from '@/modules/display/views/elevator/overview/elevator-header';
import TableFilter from '@/modules/core/components/DataTable/DataTablePaginated/TableFilter';
import StatisticItem from '@/modules/display/views/elevator/elevator-statistic/StatisticItem';
import ElevatorService from '@/modules/display/services/elevator-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ElevatorStatistic",
  components: {
    TableFilter,
    StatisticItem
  },
  data() {
    return {
      items: [],
      filterObject: null,
      page: 1,
      length: 0,
      loader: false,
      elevator: new ElevatorHeader()
    };
  },
  watch: {
    page() {
      this.updateStatistic(this.filterObject);
    }
  },
  computed: {
    headers() {
      this.$t('');
      return this.elevator.getHeader();
    }
  },
  methods: {
    updateStatistic(filter) {

      let paginator = {
        page: this.page-1,
        search: '',
        size: 10,
        sort: 'name',
        sortAsc: true
      };
      this.loader = true;

      ElevatorService.getStatistics(
        paginator,
        ElevatorService.updateFilterForSend(filter),
        (response) => {
          this.items = response.data.content;
          this.length = response.data.totalPages;
          this.loader = false;
        },
        () => {
          this.loader = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/elevator:statistic.load-error')}));
        }
      )
    },
    filterChanged(filter) {
      this.filterObject = filter;
      if (this.page === 1) {
        this.updateStatistic(filter);
      } else {
        this.page = 1;
      }
    }
  },
  mounted() {
    this.filterObject = {id: null};
    this.updateStatistic(this.filterObject);
  }
}
</script>